import React from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'
import { locale as devlocale, loadMessages } from 'devextreme/localization'

import english from './locales/en-US'
import italian from './locales/it-IT'

const locales = {
  'it-IT': italian,
  'en-US': english,
}

const mapStateToProps = ({ settings }) => ({ settings })
loadMessages({en: { "Yes": "Si", "No": "No" }});
const Localization = ({ children, settings: { locale } }) => {
  devlocale('it')
  const currentLocale = locales[locale]
  return (
    <ConfigProvider locale={currentLocale.localeAntd}>
      <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
        {children}
      </IntlProvider>
    </ConfigProvider>
  )
}

export default connect(mapStateToProps)(Localization)
